import { useSelector } from "react-redux";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type FareclassShelfBrandName,
  FlightRatingsEnum,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useFlightListGridFilter } from "@tenant/flights";
import clsx from "clsx";
import { getFareclassOptionFilter } from "../../../search/store";
import defaultStyles from "./FlightListGridFilter.module.scss";

export interface FlightListGridFilterComponentProps
  extends PlatformComponentProps {}
export const FlightListGridFilter = ({
  className,
  children,
}: FlightListGridFilterComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightListGridFilter;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();
  const fareClasses = useSelector(getFareclassOptionFilter);
  const { handleFilterFareClasses } = useFlightListGridFilter();

  const filters = [
    {
      key: FlightRatingsEnum[FlightRatingsEnum.basic],
      label: t("fareClass.basicLabel"),
      details: t("fareClass.basicDetails"),
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.standard],
      label: t("fareClass.standardLabel"),
      details: t("fareClass.standardDetails"),
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.enhanced],
      label: t("fareClass.enhancedLabel"),
      details: t("fareClass.enhancedDetails"),
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.premium],
      label: t("fareClass.premiumLabel"),
      details: t("fareClass.premiumDetails"),
    },
    {
      key: FlightRatingsEnum[FlightRatingsEnum.luxury],
      label: t("fareClass.luxuryLabel"),
      details: t("fareClass.luxuryDetails"),
    },
  ];

  return (
    <div className={clsx(block, className)}>
      <button
        className={cn("item", {
          all: true,
          selected: Object.values(fareClasses).every(
            (fareClass) => fareClass === false
          ),
        })}
        key={"all"}
        onClick={() => {
          handleFilterFareClasses("all");
        }}
      >
        {t("fareClass.all")}
      </button>
      {filters.map((filter) => {
        return (
          <button
            className={cn("item", { selected: fareClasses[filter.key] })}
            key={filter.key}
            onClick={() => {
              handleFilterFareClasses(filter.key as FareclassShelfBrandName);
            }}
          >
            {filter.label}
          </button>
        );
      })}
      {children}
    </div>
  );
};
